export default __webpack_public_path__ + "static/wvs-logo-620afe44d7a5b91ba8067aa8c639e22e.svg";